import { useFormContext } from 'react-hook-form';
import { Alert, AlertContent, AlertTitle } from '@heroui/react';

export const FormErrors = () => {
  const {
    formState: { errors }
  } = useFormContext();

  if (!errors?.root?.message) return null;

  return (
    <Alert status="danger">
      <Alert.Indicator />
      <AlertContent>
        <AlertTitle>{errors.root.message}</AlertTitle>
      </AlertContent>
    </Alert>
  );
};
